import { render, staticRenderFns } from "./serviceStoreItem.vue?vue&type=template&id=222e81b5&scoped=true&"
import script from "./serviceStoreItem.vue?vue&type=script&lang=js&"
export * from "./serviceStoreItem.vue?vue&type=script&lang=js&"
import style0 from "./serviceStoreItem.vue?vue&type=style&index=0&id=222e81b5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e81b5",
  null
  
)

export default component.exports